export interface RegulationItem {
  name: string;
  authority: string;
  renewal: string;
  note: string;
}

export interface RegulationCategory {
  id: string;
  label: string;
  icon: string;
  image: string;
  title: string;
  badge: string;
  items: RegulationItem[];
}

// Language-independent metadata (icons and images) keyed by category id.
export const REGULATION_META: Record<string, { icon: string; image: string }> = {
  business: {
    icon: 'ri-building-line',
    image:
      'https://readdy.ai/api/search-image?query=official%20business%20licenses%20permits%20and%20certificates%20laid%20out%20neatly%20on%20a%20professional%20wooden%20desk%20with%20a%20pen%20and%20glasses%20arranged%20beside%20the%20documents%20warm%20natural%20daylight%20from%20a%20nearby%20window%20soft%20shadows%20on%20the%20paper%20crisp%20legible%20seals%20and%20signatures%20on%20government%20forms%20executive%20office%20setting%20with%20subtle%20blurred%20shelves%20of%20regulatory%20binders%20in%20the%20background%20editorial%20product%20photography%20clean%20sophisticated%20aesthetic%20high%20detail%20harmonious%20composition&width=600&height=400&seq=regbizdocsv3&orientation=landscape',
  },
  'hcd-insignia': {
    icon: 'ri-shield-check-line',
    image:
      'https://readdy.ai/api/search-image?query=California%20state%20government%20regulatory%20certification%20metal%20label%20plate%20being%20inspected%20on%20a%20commercial%20food%20vehicle%20official%20documents%20and%20compliance%20paperwork%20on%20a%20professional%20desk%20warm%20ambient%20lighting%20modern%20governmental%20aesthetic%20editorial%20photography%20with%20certification%20stamps%20and%20inspector%20clipboard&width=600&height=400&seq=reghcdinsig&orientation=landscape',
  },
  health: {
    icon: 'ri-heart-pulse-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20stainless%20steel%20commercial%20kitchen%20equipment%20being%20installed%20inside%20a%20food%20truck%20build%20workshop%20NSF%20certified%20appliances%20refrigerator%20griddle%20fryer%20being%20mounted%20by%20technician%20clean%20industrial%20environment&width=600&height=400&seq=reghealth2&orientation=landscape',
  },
  vehicle: {
    icon: 'ri-truck-line',
    image:
      'https://readdy.ai/api/search-image?query=food%20truck%20serving%20window%20being%20cut%20and%20installed%20in%20a%20commercial%20vehicle%20conversion%20workshop%20vinyl%20wrap%20and%20exterior%20signage%20being%20applied%20to%20a%20step%20van%20body%20painter%20working%20on%20custom%20wrap%20design%20wide%20angle&width=600&height=400&seq=regveh2&orientation=landscape',
  },
};

export const REGULATION_ORDER = ['business', 'hcd-insignia', 'health', 'vehicle'];